export default function normBoolean(value) {
  return !!value
}
